// @ts-nocheck
/* eslint-disable */
export const normalIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path stroke="#F4B82D" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 6h9.333M3 9.667h9.333"/></svg>`,
    name: 'normal' as const
};